// removed by extract-text-webpack-plugin
module.exports = {"NormalSettings":"NormalSettings__1e2KN","MobileSettings":"MobileSettings__1x6tH"};


//////////////////
// WEBPACK FOOTER
// ./components/Buttons/SettingsButton/style.scss
// module id = Qgwq
// module chunks = 0